import { useContext } from 'react'

import { KpiRuptureContext } from '@provider/Kpi/RuptureProvider'

import type { IKpiRuptureContext } from '@base/@types/providers/Kpi/RuptureProvider'

export default function useKpiRupture(): IKpiRuptureContext {
  const context = useContext(KpiRuptureContext)

  return context
}
